export type TelemetryAspect = 'gpsPosition' | 'gpsTime' | 'gpsSpeed' | 'imu'

export type FindingLevel = 'stream' | 'reading' | 'lap'

export type FindingVerdict = 'dropped' | 'unreliable' | 'unusable'

export interface Finding {
  check: string
  level: FindingLevel
  verdict: FindingVerdict
  aspect?: TelemetryAspect
  affected?: number
  of?: number
  laps?: number[]
  reason: string
}

const isUnusableGps = (finding: Finding): boolean =>
  finding.aspect === 'gpsPosition' && finding.verdict === 'unusable'

export const hasUnusableGps = (findings: readonly Finding[]): boolean =>
  findings.some(isUnusableGps)

export function unusableGpsReasonOf(
  findings: readonly Finding[]
): string | null {
  const reasons = findings
    .filter(isUnusableGps)
    .map((finding) => finding.reason)
  return reasons.length === 0 ? null : reasons.join('; ')
}

export interface SessionShown {
  readonly sessionName?: string
  readonly sessionsShown: number
}

const ONLY_SESSION_SHOWN: SessionShown = { sessionsShown: 1 }

const sessionCalled = ({ sessionName, sessionsShown }: SessionShown): string =>
  sessionsShown <= 1 ? 'This session' : sessionName ?? 'A session'

export const cantBeAnalysedText = (
  reason: string,
  shown: SessionShown = ONLY_SESSION_SHOWN
): string => `${sessionCalled(shown)} can't be analysed: ${reason}`
